export type ShortSettings = {
    text: string,
    maxCharsOn: boolean,
    maxChars: number
}

export const SHORT_SETTINGS : ShortSettings = {
    text: "",
    maxCharsOn: false,
    maxChars: 0
};

export type LongSettings = {
    text: string,
    maxCharsOn: boolean,
    maxChars: number
}

export const LONG_SETTINGS : LongSettings = {
    text: "",
    maxCharsOn: false,
    maxChars: 0
};

export type EmailSettings = {
    email: string
    requireBusinessOn: boolean,
}

export const EMAIL_SETTINGS : EmailSettings = {
    email: "", 
    requireBusinessOn: false,
};

export type WebsiteSettings = {
    URL: string
}

export const WEBSITE_SETTINGS : WebsiteSettings = {
    URL: "",
};

export type MutlipleSettings = {
    choices: string[],
    otherValue: string,
    multiSelectOn: boolean,
    randomizeOn: boolean,
    hasOtherOn: boolean,
    enforceMinOn: boolean,
    minChoices: number,
    enforceMaxOn: boolean,
    maxChoices: number,
}

export const MULTIPLE_SETTINGS = {
    choices: [],
    otherValue: "",
    multiSelectOn: false,
    randomizeOn: false,
    hasOtherOn: false,
    enforceMinOn: false,
    minChoices: 0,
    enforceMaxOn: false,
    maxChoices: 0,
};

export type DateSettings = {
    date: string;
    dateFormat: string;
}

export const DATE_FORMATS = [
    "MM/DD/YYYY",
    "DD/MM/YYYY",
    "YYYY/MM/DD",
];

export const DATE_FORMAT_DEFAULT = "MM/DD/YYYY";

export const DATE_SETTINGS : DateSettings = {
    date: Date.now().toString(),
    dateFormat: DATE_FORMAT_DEFAULT,
};

export type FileUploadSettings = {
    fileName: string,
    assetURL: string
}

export const FILE_UPLOAD_SETTINGS : FileUploadSettings = {
    fileName: "",
    assetURL: ""
};

export type NumberSettings = {
    number: number;
    minNumOn: boolean,
    minNum: number,
    maxNumOn: boolean,
    maxNum: number,
}

export const NUMBER_SETTINGS : NumberSettings = {
    number: 0,
    minNumOn: false,
    minNum: 0,
    maxNumOn: false,
    maxNum: 0,
};

export type PhoneSettings = {
    phone: string;
    defaultCountryCode: string;
}

export const PHONE_SETTINGS : PhoneSettings = {
    phone: "",
    defaultCountryCode: "us",
};

export type ContactSettings = {
    firstName: string,
    firstNameRequired: boolean,
    firstNameVisible: boolean,
    lastName: string,
    lastNameRequired: boolean,
    lastNameVisible: boolean,
    phone: string,
    phoneRequired: boolean,
    phoneVisible: boolean,
    defaultCountryCode: string,
    email: string,
    emailRequired: boolean,
    emailVisible: boolean,
    company: string,
    companyRequired: boolean,
    companyVisible: boolean,
}

export const CONTACT_SETTINGS : ContactSettings = {
    firstName: "",
    firstNameRequired: true,
    firstNameVisible: true,
    lastName: "",
    lastNameRequired: true,
    lastNameVisible: true,
    phone: "",
    phoneRequired: true,
    phoneVisible: true,
    defaultCountryCode: "us",
    email: "",
    emailRequired: true,
    emailVisible: true,
    company: "",
    companyRequired: true,
    companyVisible: true,
};

export type NPSSettings = {
    score: number
}


export const NPS_SETTINGS : NPSSettings = {
    score: 0,
}

export type ScoreSettings = {
    score: number
    minScore: number,
    maxScore: number
    leftLabelOn: boolean,
    leftLabel: string,
    rightLabelOn: boolean,
    rightLabel: string,
}


export const SCORE_SETTINGS : ScoreSettings = {
    score: 0,
    minScore: 0,
    maxScore: 10,
    leftLabelOn: false,
    leftLabel: "",
    rightLabelOn: false,
    rightLabel: "",
}

export type RatingSettings = {
    score: number,
    stars: number,
}


export const RATING_SETTINGS : RatingSettings = {
    score: 0,
    stars: 5,
}

export type SectionSettings = {
    fontSize: number;
}


export const SECTION_SETTINGS : SectionSettings = {
    fontSize: 16,
}

export type EndSettings = {
    socialShareOn: boolean,
    brandingOn: boolean
}


export const END_SETTINGS : EndSettings = {
    socialShareOn: true,
    brandingOn: true,
}

export const QUESTION_TITLES = {
    "SHORT": "Your question here...",
    "LONG": "Your question here...",
    "MULTIPLE": "Please pick and answer",
    "EMAIL": "Enter an email address",
    "WEBSITE": "Enter a website URL",
    "DATE": "Enter a date",
    "FILE_UPLOAD": "Upload a file",
    "NUMBER": "Enter a number",
    "PHONE": "Enter a phone number",
    "CONTACT": "Enter your contact information",
    "NPS": "How likely are you to recommend us to a friend or colleague?",
    "SCORE": "Please rate this",
    "RATING": "Please rate this",
    "SECTION": "Section header (please edit)",
    "END": "Thank You",
}